import { cibWhatsapp, cilPhone, cilTouchApp } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CButtonGroup,
  CCardText,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makePhoneCall } from 'src/redux/calling'
import { sendWhatsAppMessage } from 'src/redux/sendwhatsapp'
import { getShoppingCart } from 'src/redux/shoppingcart'
import { DateTimeConverter } from 'src/utils/function'

const ShoppingCart = () => {
  const [selectedProduct, setSelectedProduct] = useState(null) // Track selected product
  const [modalVisible, setModalVisible] = useState(false) // Modal state

  const dispatch = useDispatch()

  const { cartItems } = useSelector((state) => state.shoppingcart)

  useEffect(() => {
    dispatch(getShoppingCart())
  }, [dispatch])

  const handleView = (product) => {
    setSelectedProduct(product)
    setModalVisible(true)
  }

  const handleCalling = (number) => {
    const body = {
      fromNumber: '+918554843519',
      toNumber: `+91${number}`,
    }

    try {
      dispatch(makePhoneCall(body))
    } catch (error) {
      console.log(error)
    }
  }

  const handleWhatsApp = (item) => {
    const productName = item.product_details.name
    const productWeight = item.product_details.weight
    const quantity = item.quantity
    const price = item.price
    const address = item.address
    const customerName = item.name

    const message = `Hello ${customerName}, 👋
  
You had added *${productName}* (${productWeight}) to your cart. 🛒
  
Quantity: ${quantity}
Price per unit: ₹${price}
  
We noticed you haven't completed your order yet. 🕑
Order now to enjoy fresh meat delivered to your doorstep! 🚚🥩
  
Delivery Address:
${address}
  
Tap the link to complete your order or reply to this message!
  
Thank you,
Freshymeat Team`

    const body = {
      type: 'whatsapp', // otp or whatsapp
      to: `+91${item.whatsapp_no ? item.whatsapp_no : item.mobile_no}`,
      message: message,
      images: item.product_details.images, // sending image along with message
    }

    dispatch(sendWhatsAppMessage(body))
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CTable align="middle" className="mb-0 border" hover responsive>
          <CTableHead color="light">
            <CTableRow>
              <CTableHeaderCell className="text-center">#</CTableHeaderCell>
              <CTableHeaderCell>Name</CTableHeaderCell>
              <CTableHeaderCell>Mobile</CTableHeaderCell>
              {/* <CTableHeaderCell>Username</CTableHeaderCell> */}
              {/* <CTableHeaderCell>City</CTableHeaderCell> */}
              {/* <CTableHeaderCell>State</CTableHeaderCell> */}
              {/* <CTableHeaderCell>Country</CTableHeaderCell> */}
              <CTableHeaderCell className="text-center">Quantity</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Price</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Discount</CTableHeaderCell>
              <CTableHeaderCell>Items Added</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Email</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Address</CTableHeaderCell>
              {/* <CTableHeaderCell className="text-center">Created</CTableHeaderCell> */}
              {/* <CTableHeaderCell className="text-center">Updated</CTableHeaderCell> */}
              <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {cartItems?.map((item, index) => (
              <CTableRow v-for="item in tableItems" key={index}>
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{index + 1}) </small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.name}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.mobile_no}</small>
                  </div>
                </CTableDataCell>
                {/* <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.username}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.city}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.state}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.country}</small>
                  </div>
                </CTableDataCell> */}
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.quantity}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">₹{item.price}</small>
                  </div>
                </CTableDataCell>
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">
                      {item.discount ? item.discount : 'NA'}
                    </small>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  <div className="clearfix">
                    <small className="text-medium-emphasis">
                      {DateTimeConverter(item.date_added)}
                    </small>
                  </div>
                </CTableDataCell>
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">
                      {item.email_id ? item.email_id : 'NA'}
                    </small>
                  </div>
                </CTableDataCell>
                <CTableDataCell className="text-center">
                  <div className="clearfix">
                    <small className="text-medium-emphasis">{item.address}</small>
                  </div>
                </CTableDataCell>
                {/* <CTableDataCell className="text-center">
                      <div className="clearfix">
                        <small className="text-medium-emphasis">
                          {DateTimeConverter(item.createdAt)}
                        </small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div className="clearfix">
                        <small className="text-medium-emphasis">
                          {DateTimeConverter(item.updatedAt)}
                        </small>
                      </div>
                    </CTableDataCell> */}
                <CTableDataCell className="text-center">
                  <CButtonGroup role="group" aria-label="Basic mixed styles example">
                    <CButton
                      color="secondary"
                      size="sm"
                      onClick={() => handleView(item.product_details)}
                    >
                      <CIcon icon={cilTouchApp} className="text-white" />
                    </CButton>
                    <CButton color="info" size="sm" onClick={() => handleCalling(item.mobile_no)}>
                      <CIcon icon={cilPhone} className="text-white" />
                    </CButton>
                    <CButton color="success" size="sm" onClick={() => handleWhatsApp(item)}>
                      <CIcon icon={cibWhatsapp} className="text-white" />
                    </CButton>
                  </CButtonGroup>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </CContainer>

      <CModal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader closeButton>
          <CModalTitle>{selectedProduct?.name}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {selectedProduct && (
            <>
              <img
                src={selectedProduct.images || 'placeholder.jpg'}
                alt={selectedProduct.name}
                className="img-fluid mb-3"
                style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
              />
              <CContainer>
                <CTable striped bordered hover responsive>
                  <CTableBody>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Weight</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.weight}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Pieces</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.pieces}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Serves</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.serves}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Price</strong>
                      </CTableDataCell>
                      <CTableDataCell>₹{selectedProduct.price}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Stock</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.stock}</CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>
              </CContainer>
              <CCardText>
                <strong>Description:</strong> {selectedProduct.description}
              </CCardText>
            </>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setModalVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default ShoppingCart
